<template>
    <v-btn @click="$router.go(-1)" color="black" dark>Back</v-btn> 
</template>

<script>
export default {};
</script>

<style>
</style>
